import React, { useEffect, useState } from 'react'
import { AppDispatch, RootState } from '../store/store'
import { useDispatch, useSelector } from 'react-redux'
import {
  sendNotificationByTopic,
  sendNotificationToSpecificUser,
} from '../store/actions/notificationActions'
import { selectState } from '../store/slices/notificationSlice'
import './sendNotifications.css'
import CustomButton from './CustomButton'
import useCustomStyles from '../hooks/useCustomStyles'
import { customStyles } from '../assets/styles/notificationForm'
import CustomInput from './CustomInput'
import CustomSelect from './CustomSelectInput'
import { selectTranslationState } from '../store/slices/languageSlice'
import SearchableSelect from './SearchableSelect'
import { ClientType } from '../store/slices/clientsSlice'

type TopicOption = {
  name: string
  id: string
}

const SendNotification = () => {
  const dispatch = useDispatch<AppDispatch>()
  const { loading, notifTypes, deviceTokens } = useSelector(selectState)
  const { clients, advisors } = useSelector(
    (state: RootState) => state.clients_slice,
  )
  const { businesses } = useSelector(
    (state: RootState) => state.accessCode_slice,
  )
  const [title, setTitle] = useState('')
  const [message, setMessage] = useState('')
  const [userId, setUserId] = useState('')
  const [selectedEmail, setSelectedEmail] = useState('')
  const [selectedClientId, setSelectedClientId] = useState('')
  const [topic, setTopic] = useState<string | undefined>(undefined)
  const [allUsers, setAllUsers] = useState<ClientType[]>([])
  // const [selectedToken, setSelectedToken] = useState(deviceTokens? deviceTokens[0] : '');
  // const topics = ['active', 'sopher-active','sopher-test-active' , 'sopher-test-active-clients', 'sopher-test-active-advisors','all clients' , 'all advisors', 'specific user'];
  const [selectedNotificationType, setSelectedNotificationType] = useState(
    notifTypes ? notifTypes[0] : '',
  )
  const { theme, activeTheme, textTheme } = useSelector(
    (state: RootState) => state.theme_slice,
  )
  const classes = useCustomStyles(customStyles, theme)
  const { t } = useSelector(selectTranslationState)

  const userBusinessName = useSelector(
    (state: RootState) => state.auth_slice.user?.business?.name,
  )
  console.log('userBusinessName==>', userBusinessName)
  const advisorsBusinessNames = [
    'sopher',
    'sopher-test',
    'OLYMPE',
    'OLYMPE_TEST',
  ] as const

  const showFullOptions = advisorsBusinessNames.includes(
    userBusinessName as typeof advisorsBusinessNames[number],
  )
  const [topics, setTopics] = useState<TopicOption[]>(
    userBusinessName === 'elisyan'
      ? [
          { name: 'specific user', id: 'specific user' },
          { name: 'all', id: 'active' },
          {
            name: `all ${userBusinessName} users`,
            id: `${userBusinessName}-active`,
          },
          {
            name: `all ${userBusinessName} clients`,
            id: `${userBusinessName}-active-clients`,
          },
        ]
      : [
          { name: 'specific user', id: 'specific user' },
          ...(showFullOptions
            ? [
                {
                  name: `all ${userBusinessName} users`,
                  id: `${userBusinessName}-active`,
                },
              ]
            : []),
          {
            name: `all ${userBusinessName} clients`,
            id: `${userBusinessName}-active-clients`,
          },
          ...(showFullOptions
            ? [
                {
                  name: `all ${userBusinessName} advisors`,
                  id: `${userBusinessName}-active-advisors`,
                },
              ]
            : []),
        ],
  )

  useEffect(() => {
    console.log('businesses from notifications', businesses, userBusinessName)
    if (userBusinessName === 'elisyan' && businesses) {
      for (const business of businesses) {
        if (business.type === 'partner') {
          console.log('business name for loop', business)
          setTopics((state) => {
            return [
              ...state,
              {
                name: `all ${business.name} users`,
                id: `${business.name}-active`,
              },
              {
                name: `all ${business.name} clients`,
                id: `${business.name}-active-clients`,
              },
            ]
          })
        }
      }
    }
  }, [businesses])

  useEffect(() => {
    console.log('topic', topic)
  }, [topic])

  //console.log('activetheme, mode', activeTheme, mode)
  //console.log('theme::::>>>>>>>>>>>',theme.colorSchema.colors.mainText)
  const handleTopicChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setTopic(e.target.value)
  }

  const handleTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTitle(e.target.value)
  }

  // const handleUserIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setUserId(e.target.value);
  // };

  const handleMessageChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setMessage(e.target.value)
  }
  /*
  const handleUserIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setUserId(e.target.value);
  };
 

  const handleTokenChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedToken(e.target.value);
  };

 

  const handleClick = () => {
    if (selectedToken) {
      dispatch(sendNotification({ message, title, token: selectedToken , type: selectedNotificationType})); // Include all necessary data
    } else {
      // Handle case where no token is selected
      console.error('Please select a device token');
    }
  };
 */

  useEffect(() => {
    console.log('device tokens', deviceTokens)
  }, [deviceTokens])

  // const getUserBackup = () => {
  //   dispatch(getUserCredentialBackup(userId)); // Include all necessary data
  // }
  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedNotificationType(e.target.value)
  }
  // const sendNotifByTopic = () => {
  //   if (topic) {
  //     dispatch(sendNotificationByTopic({ message, title, topic, type: selectedNotificationType, userId })); // Include all necessary data
  //   } else {
  //     console.error('Please select a topic');
  //   }
  // }

  const handleSendNotification = async () => {
    if (topic == 'specific user' && userId) {
      dispatch(
        sendNotificationToSpecificUser({
          message,
          title,
          userId,
          type: selectedNotificationType,
        }),
      ) // Include all necessary data
    } else if (topic && topic !== 'specific user') {
      dispatch(
        sendNotificationByTopic({
          message,
          title,
          topic,
          type: selectedNotificationType,
          userId,
        }),
      )
    }
  }

  useEffect(() => {
    setAllUsers((state) => {
      return [
        ...state,
        ...(clients ? clients : []),
        ...(advisors ? advisors : []),
      ]
    })
  }, [clients, advisors])

  return (
    <div className={classes?.container}>
      {/** <div className="notification-form">
      <input
          type="text"
          name="userId"
          placeholder="UserId"
          className="notification-input"
          value={userId}
          onChange={e => handleUserIdChange(e)}
        />
      <button onClick={getUserBackup}>Get user backup</button>
    </div> */}

      {/*
    <div className="notification-form">
      <h2 className='title'>Create Notification</h2>
      
      <select name="device-token-select" className="device-token-select" value={selectedToken} onChange={e => handleTokenChange(e)}>
      <option value="" disabled>Select a device token</option>
        {deviceTokens && deviceTokens.map((token, index) => (
          <option key={index} value={token}>
            {token}
          </option>
        ))}
      </select>
  
      <select name="notification-type-select" className="device-token-select" value={selectedNotificationType} onChange={e => handleTypeChange(e)}>
      <option value="" disabled>Select the type</option>
        {notifTypes && notifTypes.map((type, index) => (
          <option key={index} value={type}>
            {type}
          </option>
        ))}
      </select>
      <input
        type="text"
        name="title"
        placeholder="Title"
        className="notification-input"
        value={title}
        onChange={e => handleTitleChange(e)}
      />
      <textarea
        name="message"
        value={message}
        placeholder="Put message here..."
        className="notification-textarea"
        onChange={e => handleMessageChange(e)}
      />
      <button className={loading? 'loadingButton' : 'button'} onClick={handleClick} disabled={title.length == 0 || message.length == 0}>{loading ?  <img className='loadingIcon' src={LoadingCercle} alt="loadingGif" /> : 'Send Message'}</button>
      <h5 className='error'>{error}</h5>
    </div>
   */}
      <h2 className={classes?.title}>
        {t[textTheme].notificationScreen.form.title}
      </h2>
      <div className={classes?.notificationForm}>
        {/* <hr className={classes?.divider}></hr> */}

        <CustomSelect
          placeholder="Select a topic"
          label="Type"
          name={'type'}
          value={selectedNotificationType}
          options={notifTypes}
          onChange={(e) => handleTypeChange(e)}
        />
        <CustomSelect
          placeholder="Select a target"
          label="Target"
          name={'topic'}
          value={topic}
          options={topics}
          onChange={(e) => handleTopicChange(e)}
        />

        {topic && topic === 'specific user' && (
          <>
            {' '}
            <SearchableSelect
              label="Search By Email"
              options={allUsers.map((client) => client.email)}
              value={selectedEmail}
              onChange={(value: string) => {
                const filtered = allUsers?.find(
                  (client) => client.email === value,
                )
                setUserId(filtered?.app_user_id || '')
                setSelectedEmail(value)
                setSelectedClientId(
                  filtered?.clientId
                    ? filtered.clientId
                    : filtered?.app_user_id || '',
                )
              }}
              placeholder="Search by email..."
            />
            <SearchableSelect
              label="Search By Email"
              options={allUsers.map((client) =>
                client.clientId ? client.clientId : client.app_user_id,
              )}
              value={selectedClientId}
              onChange={(value: string) => {
                const filtered = allUsers?.find(
                  (client) =>
                    client.clientId === value || client.app_user_id === value,
                )
                setUserId(filtered?.app_user_id || '')
                setSelectedClientId(value)
                setSelectedEmail(filtered?.email || '')
              }}
              placeholder="Search by client id..."
            />
          </>
        )}
        <CustomInput
          label="Title"
          name="title"
          value={title}
          placeholder={
            t[textTheme].notificationScreen.form.titleInput.placeholder
          }
          onChange={(e) => handleTitleChange(e)}
        />
        <textarea
          name="message"
          value={message}
          placeholder={
            t[textTheme].notificationScreen.form.textArea.placeholder
          }
          className={classes?.notificationTextarea}
          onChange={(e) => handleMessageChange(e)}
        />
        <CustomButton
          title={t[textTheme].notificationScreen.form.button.title}
          name="sendNotificationByTopic"
          handleClick={handleSendNotification}
          disabled={
            title.length == 0 ||
            message.length == 0 ||
            topic === undefined ||
            topic.length === 0 ||
            (topic === 'specific user' && userId.length === 0)
          }
          loading={loading}
        />
      </div>
    </div>
  )
}

export default SendNotification
